import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

import * as styles from './RemoveFromSubscriptionModal.css';

type SellWithSubscriptionModalProps = {
  isOpen: boolean;
  programName: string;
  isConfirming?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const SellWithSubscriptionModal = ({
  isOpen,
  programName,
  isConfirming = false,
  onConfirm,
  onClose,
}: SellWithSubscriptionModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Make your content visible"
      modalClassName={styles.modalWidth}
      centerContent={true}
    >
      <div
        className={styles.content}
        data-testid="sell-with-subscription-modal"
      >
        {programName ? (
          <Typography variant="body" size="large" fontWeight="bold">
            {programName}
          </Typography>
        ) : null}
        <Typography variant="body" size="large" fontWeight="normal">
          Programs that are part of any published offer or your live
          subscription will be visible &amp; published to your users.
        </Typography>
        <Typography variant="body" size="large" fontWeight="normal">
          Users without access will be asked to pay for access.
        </Typography>
        <div className={styles.actions}>
          <Button variant="text" color="neutral" onClick={onClose}>
            Cancel
          </Button>
          <Button color="neutral" onClick={onConfirm} disabled={isConfirming}>
            Yes, publish program &amp; proceed
          </Button>
        </div>
      </div>
    </Modal>
  );
};
